import React from 'react';
// import './Home.css';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';


const Contact = () => {
    return (
        <>
            <Header />
            <div> <p> Hello Contact</p></div>
            <Footer />
        </>

    )
}

export default Contact;